import { styled } from '@mui/material'
import { blackToTransparentGradient } from '$setup/style/helpers'

export const CreateStoryHeader = styled('div')`
  display: flex;
  width: 100%;
  padding: 8px;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  height: 56px;
  position: relative;
  z-index: 1;
  background: ${blackToTransparentGradient('bottom')};
`
